import { Injectable } from '@angular/core';

const WIND_STRENGTH_MULTIPLER = 1.9438461717893;

@Injectable()
export class ChartService {

  constructor() { }

  /**
   * Metoda zwracająca odwrócony o 180 stopni kierunek wiatru
   * @param {string} windDirection
   * @returns {number}
   */
  public reverseWindDirection (windDirection: number): number {
    if (windDirection >= 0 && windDirection <= 180) {
      windDirection = windDirection + 180;
    } else {
      windDirection = windDirection - 180;
    }
    return windDirection;
  };

  /**
   * Metoda przeliczająca prędkość wiatru z m/s na kts
   * @param {string} windStrength
   * @returns {number}
   */
  public convertWindStrength (windStrength: string): number {
    const windStrengthValue: number = parseFloat(windStrength);
    return parseInt((windStrengthValue * WIND_STRENGTH_MULTIPLER * 100).toString(), 10) / 100;
  };

  /**
   * Metoda parsująca datę z JSONa i zwracająca JS-owy obiekt Date
   * @param {string} date
   * @returns {Date}
   */
  public parseDateToJSObject (date: string): Date {
    const dArray = date.split(' ');
    const dateArray = dArray[0].split('-');
    const timeArray = dArray[1].split(':');
    const y: number = parseInt(dateArray[0], 10);
    const m: number = parseInt(dateArray[1], 10) - 1;
    const d: number = parseInt(dateArray[2], 10);
    const h: number = parseInt(timeArray[0], 10);
    const i: number = parseInt(timeArray[1], 10);
    const s: number = parseInt(timeArray[2], 10);

    return new Date(y, m, d, h, i, s);
  };

}



// WEBPACK FOOTER //
// ./src/app/chart/chart.service.ts